/* Data Imports */
import { ReactComponent as ClickMeIcon } from '../../../../assets/svg/click_me_icon.svg';

/* HTML */
export default function ClickMeButton() {
  return (
    <ClickMeIcon className='click-me-button' />
  )
};